import { Sparkles, ArrowRight } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

// FIN-4 — SugestaoConcentracaoCard.
// Renderiza só quando concentrationWarning.is_concentrated == true.
// CTA "Conversar com o Nexo" abre overlay de voz com pre-prompt
// contextual baseado em warning_type.

const PROMPTS_BY_TYPE = {
  high_volatility:
    "Minha carteira está concentrada em renda variável e cripto. " +
    "Como posso diversificar com renda fixa de forma equilibrada?",
  single_asset:
    "Tenho um ativo concentrando muito da minha carteira. " +
    "Faz sentido manter essa posição? Ou vale balancear?",
  single_institution:
    "Minha carteira está concentrada em uma única instituição. " +
    "Quais riscos isso traz e como reduzir?",
};

export default function SugestaoConcentracaoCard({ warning, onTalk }) {
  if (!warning?.is_concentrated) return null;

  const promptHint =
    PROMPTS_BY_TYPE[warning.warning_type] ||
    "Como está a diversificação da minha carteira de investimentos?";

  return (
    <Card
      variant="elevated"
      className="glass-card-strong gradient-border-cyan glow-hover p-5 md:p-6 flex items-start gap-3"
      data-testid="invest-sugestao-concentracao"
    >
      <div className="w-10 h-10 rounded-lg bg-brand-cyan/15 flex items-center justify-center shrink-0">
        <Sparkles className="w-5 h-5 text-brand-cyan" aria-hidden="true" />
      </div>
      <div className="flex-1 min-w-0">
        <p
          className="text-micro text-brand-cyan uppercase font-semibold mb-1"
          style={{ letterSpacing: "0.10em" }}
        >
          Sugestão do Nexo
        </p>
        <p className="text-caption text-foreground mb-2">
          {warning.message}
        </p>
        {onTalk && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onTalk(promptHint)}
            className="px-2 h-auto py-1 text-brand-cyan hover:text-brand-cyan-strong"
            data-testid="invest-sugestao-talk"
          >
            Conversar com o Nexo sobre minha carteira
            <ArrowRight className="w-3.5 h-3.5" />
          </Button>
        )}
      </div>
    </Card>
  );
}
